import AsyncSelect from 'react-select/async';
import debounce from 'debounce-async';
import { useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { producer_autosuggest } from '../../../../api/api';
import MetadataSelect, { buildMetadataPayload } from './MetadataSelect';


const ProducerSideBar = ({ pullback, defaultValue, metadataPullback, metadataDefaults, children }) => {

     const [value, setValue] = useState(null);
     const [metadataValues, setMetadataValues] = useState({
          developer: [],
          publisher: [],
          collection: [],
          country: [],
     });

     const loadOption = useMemo(() => {
          return debounce(async (inputValue) => {
               const { data } = await axios.get(producer_autosuggest(inputValue))

               const options = data.map((account) => ({
                    value: account.userId,
                    label: `${account.firstName} (${account.lastName})`,
               }));

               return options;
          }, 300);
     }, []);

     useEffect(() => {
          if (metadataDefaults) {
               setMetadataValues(metadataDefaults)
          }
     }, [metadataDefaults])

     useEffect(() => {
          if (metadataPullback) {
               metadataPullback(buildMetadataPayload(metadataValues))
          }
     }, [metadataValues, metadataPullback])

     const handleChangeAutoSuggest = (selectedOption) => {
          pullback(selectedOption.value)
          setValue(selectedOption)
     }

     const handleMetadataChange = (key) => (option) => {
          setMetadataValues((prev) => ({ ...prev, [key]: option }))
     }



     return (
          <>
               <div className="boxHolderPosts">
                    <div className="titleBar">مشخصات</div>

                    <div style={{ marginBottom: '1rem' }}>
                         <AsyncSelect
                              cacheOptions
                              placeholder='تولید کننده'
                              value={value ? value : defaultValue}
                              loadOptions={loadOption}
                              onChange={handleChangeAutoSuggest}
                              noOptionsMessage={() => 'تولید کننده ای یافت نشد!'}
                              loadingMessage={() => 'لطفا صبر کنید...'}
                              isRtl
                              required={true}
                         />
                    </div>

                    <MetadataSelect
                         type={0}
                         placeholder='کمپانی سازنده'
                         value={metadataValues.developer}
                         onChange={handleMetadataChange('developer')}
                         isMulti
                    />
                    <MetadataSelect
                         type={1}
                         placeholder='کمپانی ناشر'
                         value={metadataValues.publisher}
                         onChange={handleMetadataChange('publisher')}
                         isMulti
                    />
                    <MetadataSelect
                         type={2}
                         placeholder='کالکشن'
                         value={metadataValues.collection}
                         onChange={handleMetadataChange('collection')}
                         isMulti
                    />
                    <MetadataSelect
                         type={3}
                         placeholder='کشور'
                         value={metadataValues.country}
                         onChange={handleMetadataChange('country')}
                         isMulti
                    />

                    {children}
               </div>
          </>
     )
}

export default ProducerSideBar
